const RatingWeights = {
  rfqWeight: 10,
  deliveryWeight: 10,
  rejectWeight: 10,
  transitDelayWeight: 10,
};

module.exports = { RatingWeights };
